<div class="w-full bg-gray-200 py-5 text-sm text-gray-900 text-center">Copyright 2021</div>